<template>
  <div>
    <mdb-btn
      class="searchButton btn-sm rounded mx-1 px-3"
      v-show="!clicked"
      @click="handleShareClick"
      icon="share-alt"
    >
      Share this search
    </mdb-btn>

    <section class="searchLinkInput-group z-depth-1" v-show="clicked">
      <mdb-input
        size="sm"
        basic
        id="shareSearchLink"
        v-show="clicked"
        v-model="shareSearchLink"
        type="text"
        ref="input"
      >
        <span
          v-mdb-waves
          class="searchLinkInput-group__input input-group-text text-white"
          slot="prepend"
          >Copied to clipboard:</span
        >
      </mdb-input>
    </section>
  </div>
</template>

<script>
import { mdbWaves } from "mdbvue";
export default {
  directives: {
    mdbWaves,
  },
  data() {
    return {
      clicked: false,
      shareSearchLink: "",
    };
  },
  methods: {
    reset() {
      this.clicked = false;
      this.shareSearchLink = "";
    },
    handleShareClick() {
      let searchParams = this.$store.state.searchParams;
      let params = [];
      let query = "";

      if (searchParams.testType)
        params.push("testType=" + searchParams.testType);
      if (searchParams.countries.length > 0)
        params.push("countries=" + searchParams.countries.join(","));
      if (searchParams.features.length > 0)
        params.push("features=" + searchParams.features.join(","));

      if (params.length > 0) {
        query += "?" + params.join("&");
      }

      this.shareSearchLink = window.location.href.split("?")[0] + query;
      this.clicked = true;
      this.$nextTick(() => {
        this.$refs.input.$refs.input.select();
        document.execCommand("copy");
      });
    },
  },
  watch: {
    "$store.state.searchParams"() {
      this.reset();
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/components/search/_shareSearchButton.scss";
</style>